<template>
    <div id="info-box">
        <div class="info-container">
            <div v-if="!expanded" @click="toggleExpand" class="info-i">
                i
            </div>
            <div v-else>
                <div @click="toggleExpand" class="info-x">
                    ✖
                </div>
                <p class="info-title">
                    {{description.title}}
                </p>
                <p class="info-text">
                    {{description.text}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'info-box',
  data () {
    return {
      expanded: false
    }
  },
  props: ['description'],
  methods: {
    toggleExpand () {
      if (this.expanded) {
        document.getElementsByClassName('info-container')[0].className = 'info-container'
        setTimeout(() => {
          this.expanded = false
        }, 300)
      } else {
        this.expanded = true
        document.getElementsByClassName('info-container')[0].classList.add('expand')
      }
    }
  }
}
</script>
<style scoped>
#info-box{
    float: left;
    position:absolute;
    z-index: 499;
    text-align: left;
    margin: 5px;
}
.info-container{
    background-color: rgba(0, 0, 0, 0.5);
    max-height: 30px;
    max-width: 30px;
    border: 2px #b62626 solid;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.5s ease;
}
.info-container.expand{
    padding: 5px;
    border-radius: 7%;
    max-height: 400px;
    max-width: 200px;
    cursor: default;
}
.info-i{
    width: 29px;
    height: 26px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 4px;
    margin-right: 1px;

  cursor: pointer;
}
.info-x{
    float: right;
    padding: 5px;
  cursor: pointer;
}
.info-title{
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin: 0px;
}
.info-text{
    width:200px;
}
</style>


// WEBPACK FOOTER //
// src/components/Info-Box.vue